import { render, staticRenderFns } from "./FormHome.vue?vue&type=template&id=64f31d18&"
import script from "./FormHome.vue?vue&type=script&lang=js&"
export * from "./FormHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports